import { Injectable } from '@angular/core';
import { Log } from 'src/app/core/console.log';
import { QuotationCopy } from 'src/app/models/quotation/quotation-copy';
import { factory } from '../config/constants';

@Injectable()
export class QuotationFactoryService {
  constructor() {
  }

  setQuotationId(quotationId: any) {
    sessionStorage.setItem(factory.quotationId, quotationId);
  }

  claerQuotationId() {
    sessionStorage.removeItem(factory.quotationId);
  }

  getQuotationId(): any {
    try {
      return sessionStorage.getItem(factory.quotationId);
    } catch (e) {
      return '';
    }
  }

  setQuotationNo(quotationNo: any) {
    sessionStorage.setItem(factory.quotationNo, quotationNo);
  }

  getQuotationNo(): any {
    try {
      return sessionStorage.getItem(factory.quotationNo);
    } catch (e) {
      return '';
    }
  }

  getButtonDownload(): any {
    try {
      const btn = sessionStorage.getItem(factory.buttonDownload);
      return btn === 'true' ? btn : false;
    } catch (e) {
      return '';
    }
  }

  setButtonDownload(btnDownload) {
    sessionStorage.setItem(factory.buttonDownload, btnDownload);
  }

  setQuotationForCopy(quotationCopy: QuotationCopy) {
    sessionStorage.setItem(factory.quotationCopy, JSON.stringify(quotationCopy));
  }

  setAppNoForCopy(appNo) {
    sessionStorage.setItem(factory.appNoCopy, appNo);
  }

  getQuotationForCopy(): QuotationCopy {
    try {
      const qt = JSON.parse(sessionStorage.getItem(factory.quotationCopy));
      return qt;
    } catch (e) {
      return null;
    }
  }

  clearCopyQuotation() {
    sessionStorage.removeItem(factory.quotationCopy);
  }

  setQuotationCopyType(quotationType: string) {
    sessionStorage.setItem(factory.quotationCopyType, quotationType);
  }

  getQuotationCopyType() {
    try {
      const qt = sessionStorage.getItem(factory.quotationCopyType);
      return qt;
    } catch (e) {
      return null;
    }
  }

  clearQuotationCopyType() {
    sessionStorage.removeItem(factory.quotationCopyType);
  }

  setQuotationLoaded() {
    const qt = this.getQuotationForCopy();
    if (qt) {
      qt._isLoaded = true;
      qt._shouldNotReload = false;
      this.setQuotationForCopy(qt);
    }
  }

  setQuotationShouldNotLoad(should:boolean){
    const qt = this.getQuotationForCopy();
    if (qt) {
      qt._shouldNotReload = should;
      //console.log("_shouldNotReload :" + JSON.stringify(qt))
      this.setQuotationForCopy(qt);
      //console.log("_shouldNotReload :" + JSON.stringify(this.getQuotationForCopy()))
    }
  }

  clearQuotationRefer() {
    sessionStorage.removeItem(factory.quotationRefer);
  }

  getQuickQuote() {
    try {
      const qt = sessionStorage.getItem(factory.quickQuote);
      return qt;
    } catch (error) {
      return null;
    }
  }

  getQuotePage() {
    try {
      const qt = sessionStorage.getItem(factory.quotationPage);
      return qt;
    } catch (error) {
      return null;
    }
  }
  setQuickQuote() {
    sessionStorage.setItem(factory.quickQuote, 'QQ');
  }

  setQuotDraft() {
    sessionStorage.setItem(factory.quotationPage, 'QD');
  }

  setQuotCompleted() {
    sessionStorage.setItem(factory.quotationPage, 'QC');
  }

  clearQuotePage() {
    sessionStorage.removeItem(factory.quotationPage);
  }

  clearQuickQuote() {
    sessionStorage.removeItem(factory.quickQuote);
  }

}
